import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  token: null,
  user: null,
};

export const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    setSession: (state, data) => {
      state.token = data.payload.token;
      state.user = {};
      state.user.firstName = data.payload.firstName;
      state.user.email = data.payload.email;
    },
    cleanSession: (state) => {
      state.token = null;
      state.user = null;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setSession, cleanSession } = sessionSlice.actions;

export default sessionSlice.reducer;
